module.exports = __webpack_public_path__ + "img/jiaru.8be8452a.png";